<div class="modern-admin-page">
  <!-- Page Header -->
  <div class="page-header-card">
    <div class="header-content">
      <div class="page-title-section">
        <h1 class="page-title bangla-heading">ওয়ার্ড ব্যবস্থাপনা</h1>
        <p class="page-subtitle bangla-text">ওয়ার্ড তৈরি, সম্পাদনা এবং পরিচালনা করুন</p>
      </div>
    </div>
  </div>

  <!-- Ward Entry Form -->
  <div class="content-card slide-up" id="ward-form" [class.editing-mode]="isEditing">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-plus-circle" *ngIf="!isEditing"></i>
        <i class="fas fa-edit" *ngIf="isEditing"></i>
        <span *ngIf="!isEditing">নতুন ওয়ার্ড এন্ট্রি</span>
        <span *ngIf="isEditing">ওয়ার্ড সম্পাদনা</span>
      </h3>
    </div>
    
    <div class="card-body">
      <form (ngSubmit)="onSubmit()" class="modern-form">
        <div class="form-row">
          <div class="form-group">
            <label class="form-label bangla-label required">ওয়ার্ড নং *</label>
            <input 
              [(ngModel)]="ward.ward_number" 
              name="wardNo" 
              type="number" 
              class="form-control-modern" 
              [class.error]="wardNumberError"
              placeholder="১" 
              (input)="validateWardNumber()"
              (blur)="validateWardNumber()"
              required>
            <div *ngIf="wardNumberError" class="validation-error">
              <i class="fas fa-exclamation-triangle"></i>
              <span>{{wardNumberError}}</span>
            </div>
          </div>
          
          <div class="form-group">
            <label class="form-label bangla-label required">ওয়ার্ডের নাম *</label>
            <input 
              [(ngModel)]="ward.ward_name" 
              name="wardName" 
              type="text" 
              class="form-control-modern" 
              placeholder="১ নং ওয়ার্ড">
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label bangla-label">ওয়ার্ড মেম্বারের নাম</label>
            <input 
              [(ngModel)]="ward.ward_member_name" 
              name="wardMemberName" 
              type="text" 
              class="form-control-modern" 
              placeholder="ওয়ার্ড মেম্বারের নাম">
          </div>
          
          <div class="form-group">
            <label class="form-label bangla-label">যোগাযোগের নম্বর</label>
            <input 
              [(ngModel)]="ward.contact_number" 
              name="wardMobileNumber" 
              type="text" 
              class="form-control-modern" 
              placeholder="যোগাযোগের নম্বর">
          </div>
        </div>

        <div class="form-actions">
          <button 
            type="submit" 
            class="btn-primary-modern bangla-text"
            [disabled]="!isFormValid() || isSubmitting">
            <i class="fas fa-spinner fa-spin" *ngIf="isSubmitting"></i>
            <i class="fas fa-save" *ngIf="!isSubmitting"></i>
            <span *ngIf="!isEditing && !isSubmitting">দাখিল করুন</span>
            <span *ngIf="!isEditing && isSubmitting">দাখিল করা হচ্ছে...</span>
            <span *ngIf="isEditing && !isSubmitting">আপডেট করুন</span>
            <span *ngIf="isEditing && isSubmitting">আপডেট করা হচ্ছে...</span>
          </button>
          <button type="button" class="btn-secondary-modern bangla-text" (click)="clearForm()">
            <i class="fas fa-eraser"></i>
            ক্লিয়ার করুন
          </button>
          <button type="button" *ngIf="isEditing" class="btn-outline-modern bangla-text" (click)="cancelEdit()">
            <i class="fas fa-times"></i>
            বাতিল করুন
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Ward List Section -->
  <div class="content-card slide-up">
    <div class="card-header">
      <h3 class="card-title bangla-title">
        <i class="fas fa-list"></i>
        ওয়ার্ড তালিকা
      </h3>
      <div class="card-actions">
        <span class="data-count bangla-text">
          মোট <strong>{{wardList?.length || 0}}</strong> টি ওয়ার্ড
        </span>
      </div>
    </div>

    <div class="card-body">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="loading-state">
        <div class="loading-spinner">
          <i class="fas fa-spinner fa-spin"></i>
          <p class="bangla-text">ডেটা লোড হচ্ছে...</p>
        </div>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && (!wardList || wardList.length === 0)" class="empty-state">
        <div class="empty-icon">
          <i class="fas fa-map-marker-alt"></i>
        </div>
        <h3 class="bangla-title">কোন ওয়ার্ড পাওয়া যায়নি</h3>
        <p class="bangla-text">এখনো কোন ওয়ার্ড তৈরি করা হয়নি। উপরের ফর্ম ব্যবহার করে প্রথম ওয়ার্ড তৈরি করুন।</p>
      </div>

      <!-- Data Table -->
      <div *ngIf="!isLoading && wardList && wardList.length > 0" class="table-responsive">
        <table datatable [dtOptions]="dtoptions" [dtTrigger]="dtTrigger" class="table-modern" role="table" aria-label="ওয়ার্ড তালিকা">
          <thead>
            <tr role="row">
              <th role="columnheader" class="bangla-label">ওয়ার্ড নং</th>
              <th role="columnheader" class="bangla-label">ওয়ার্ডের নাম</th>
              <th role="columnheader" class="bangla-label">ওয়ার্ড মেম্বারের নাম</th>
              <th role="columnheader" class="bangla-label">যোগাযোগের নম্বর</th>
              <th role="columnheader" class="bangla-label">এ্যাসেসমেন্ট সংখ্যা</th>
              <th role="columnheader" class="actions-column bangla-label">কার্যক্রম</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let ward of wardList; let i = index" [class.table-striped]="i % 2 === 0" role="row">
              <td class="ward-number">
                <span class="ward-badge bangla-text">{{ward.ward_number}}</span>
              </td>
              <td class="ward-name bangla-text">{{ward.ward_name}}</td>
              <td class="member-name bangla-text">{{ward.ward_member_name}}</td>
              <td class="contact-number">
                <span class="mobile-number">{{ward.contact_number}}</span>
              </td>
              <td class="assessment-count">
                <span class="count-badge bangla-text">{{ward.assessment_count || 0}}</span>
              </td>
              <td class="actions-cell">
                <div class="action-buttons-cell">
                  <button 
                    type="button"
                    title="সম্পাদনা করুন" 
                    class="btn-action-sm btn-edit"
                    (click)="updateWard(ward)"
                    [attr.aria-label]="'সম্পাদনা করুন ' + ward.ward_name">
                    <i class="far fa-edit" aria-hidden="true"></i>
                  </button>
                  
                  <button 
                    type="button"
                    *ngIf="canPerformBatchDelete()"
                    title="ওয়ার্ডের সমস্ত তথ্য মুছে ফেলুন" 
                    class="btn-action-sm btn-danger"
                    (click)="batchDeleteWardData(ward.id, ward.ward_number)"
                    [attr.aria-label]="'সমস্ত ডেটা মুছে ফেলুন ' + ward.ward_name + ' এর'">
                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>